export const formatCurrency = (amount: number, currency = "GBP") => {
  const options = {
    style: "currency",
    currency: currency,
  };

  if (amount % 1 === 0) {
    // Round number, so don't display any fractional numbers
    return amount.toLocaleString("en-GB", {
      ...options,
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
    });
  } else {
    // Non-round number, so show the pence
    return amount.toLocaleString("en-GB", {
      ...options,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }
};

export const formatCurrencyWithTwoDecimal = (
  amount: number,
  currency = "GBP",
) => {
  const options = {
    style: "currency",
    currency: currency,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  };

  return amount.toLocaleString("en-GB", options);
};

const currencyFormat = (currency: string) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency });

// The minor-unit digits of a currency — 2 for pounds, 0 for yen — read from
// Intl so a fee is constrained the way the API stores it. Two for a code
// Intl does not know.
export const currencyExponent = (currency = "GBP") => {
  try {
    return currencyFormat(currency).resolvedOptions().maximumFractionDigits;
  } catch {
    return 2;
  }
};

// The symbol formatCurrency prints, for a prefix beside an input.
export const currencySymbol = (currency = "GBP") => {
  try {
    return (
      currencyFormat(currency)
        .formatToParts(0)
        .find(({ type }) => type === "currency")?.value ??
      currency.toUpperCase()
    );
  } catch {
    return currency.toUpperCase();
  }
};
